import { Route, Routes } from "react-router-dom";
import Home4 from "./pages/Home4";
import NewYear from "./not_pushd/newyear";
import NewYear2025 from "./not_pushd/newyear_2025";
import Grievance from "./not_pushd/grievances";
export default function App() {
  return (
    <Routes>
      
      <Route path="/" element={<Home4 />} />
      <Route path="/hehe" element={<NewYear />} />
      <Route path="/iloveyou" element={<NewYear2025 />} />
      <Route path="/kaajuportal" element={<Grievance />} />
    </Routes>
  );
}
